import { MAPS_API_KEY } from '@/services/maps/API_KEY';
import { Loader } from 'google-maps';

const options = {
  libraries: ['places', 'drawing'],
};

// https://googlemaps.github.io/js-api-loader/interfaces/loaderoptions.html
// https://developers.google.com/maps/documentation/javascript/libraries
const loader = new Loader(MAPS_API_KEY, options);

export default {
  props: {
    mapId: {
      type: String,
      required: true,
    },
    country: {
      type: String,
      default: 'Argentina',
    },
    defaultLat: {
      type: [String, Number],
      default: null,
    },
    defaultLng: {
      type: [String, Number],
      default: null,
    },
    zoom: {
      type: Number,
      default: 8,
    },
    infoWindowData: {
      type: Function,
      default: null,
    },
    entityType: {
      type: String,
      default: '',
    },
    mapType: {
      type: String,
      default: 'roadmap',
      validator: (value) => {
        return ['hybrid', 'roadmap', 'satellite', 'terrain'].indexOf(value) !== -1;
      },
    },
  },
  data() {
    return {
      google: null,
      map: null,
      location: null,
      info: null,
      attempts: 3,
    };
  },
  created() {
    this.loadMap();
  },
  methods: {
    mapLoaded() {
      // This functions executes after map is fully loaded
      // Redefine this on your component to check when map loading is over
    },
    mapOptions() {
      return {
        zoom: this.zoom,
        scrollwheel: true,
        mapTypeId: this.mapType || this.google.maps.MapTypeId.ROADMAP,
        styles: [
          {
            featureType: 'administrative',
            elementType: 'labels.text.fill',
            stylers: [{ color: '#444444' }],
          },
          {
            featureType: 'landscape',
            elementType: 'all',
            stylers: [{ color: '#f2f2f2' }],
          },
          {
            featureType: 'poi',
            elementType: 'all',
            stylers: [{ visibility: 'off' }],
          },
          {
            featureType: 'road',
            elementType: 'all',
            stylers: [{ saturation: -100 }, { lightness: 45 }],
          },
          {
            featureType: 'road.highway',
            elementType: 'all',
            stylers: [{ visibility: 'simplified' }],
          },
          {
            featureType: 'road.arterial',
            elementType: 'labels.icon',
            stylers: [{ visibility: 'off' }],
          },
          {
            featureType: 'transit',
            elementType: 'all',
            stylers: [{ visibility: 'off' }],
          },
          {
            featureType: 'water',
            elementType: 'all',
            stylers: [{ color: '#5e72e4' }, { visibility: 'on' }],
          },
        ],
      };
    },
    async loadMap() {
      this.google = await loader.load();

      await this.initMap();
    },
    initMap() {
      this.map = new this.google.maps.Map(document.getElementById(this.mapId), this.mapOptions());

      this.setGeoCoder(this.geoCodeRequest());
    },
    geoCodeRequest(lat, lng) {
      let request = { address: this.country };

      if (lat && lng) {
        request = { location: { lat, lng } };
      } else if (this.defaultLat && this.defaultLng) {
        request = { location: { lat: this.defaultLat, lng: this.defaultLng } };
      }

      return request;
    },
    setGeoCoder(request) {
      this.geocoder = new this.google.maps.Geocoder();

      this.geocoder.geocode(request, (results, status) => {
        if (status === this.google.maps.GeocoderStatus.OK) {
          this.info = results[0];
          this.location = this.info.geometry.location;

          if (request.location) {
            this.map.setCenter(request.location);
          } else {
            this.map.setCenter(this.location);
          }

          this.mapLoaded();
        } else if (status === this.google.maps.GeocoderStatus.ZERO_RESULTS) {
          if (this.attempts > 0) {
            this.attempts--;
            this.setGeoCoder({ address: this.country });
          }
          this.$warning(
            this.entityType ? `No se pudo cargar ubicacion del ${this.entityType}` : 'No se pudo cargar ubicacion'
          );
        } else if (status === this.google.maps.GeocoderStatus.ERROR) {
          this.$error(`Fallo al cargar mapa.`);
        } else {
          this.$error(`Fallo al cargar ubicación, puede que haya alcanzado el límite de peticiones.`);
        }
      });
    },
    getLocationInfo(lat, lng) {
      return new Promise((resolve, reject) => {
        this.geocoder.geocode(this.geoCodeRequest(lat, lng), (results, status) => {
          if (status === this.google.maps.GeocoderStatus.OK) {
            resolve({ info: results[0], location: results[0].geometry.location, status });
          }
          reject(status);
        });
      });
    },
    infoWindowTemplate(entityModel, marker) {
      const title = marker.title || this.title;

      let infoContent = '';
      if (this.infoWindowData) {
        infoContent = this.infoWindowData(entityModel, marker);
      }

      return `
          <div class="content">
            <h4>${title}</h4>
            <div>
                ${infoContent}
            </div>
          </div>
        `;
    },
  },
};
